import { useCallback, useEffect, useState } from "react";
import { api, formatApiError, type AdminUserRow, type AppSettings } from "@/lib/api";
import { AdminSettingsForm } from "@/components/AdminSettingsForm";
import { AdminUsersPanel } from "@/components/AdminUsersPanel";
import { DemoPurgeCard } from "@/components/DemoPurgeCard";
import { InternalUsersCard } from "@/components/InternalUsersCard";
import { AdminMentorPanel } from "@/components/AdminMentorPanel";
import { AdminBillingCard } from "@/components/AdminBillingCard";
import { AdminEmailCard } from "@/components/AdminEmailCard";
import { ProdResetCard } from "@/components/ProdResetCard";

export default function AdminPage() {
  const [settings, setSettings] = useState<AppSettings | null>(null);
  const [users, setUsers] = useState<AdminUserRow[]>([]);
  const [error, setError] = useState("");

  const load = useCallback(() => {
    Promise.all([api.get<AppSettings>("/admin/settings"), api.get<{ users: AdminUserRow[] }>("/admin/overview")])
      .then(([s, o]) => { setSettings(s.data); setUsers(o.data.users); })
      .catch((err) => setError(formatApiError(err)));
  }, []);

  useEffect(load, [load]);

  return (
    <section data-testid="admin-page">
      <div className="fade-up mb-8">
        <p className="font-mono text-xs font-medium tracking-widest text-amber-600">ADMIN</p>
        <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight text-[#1B2A4A] sm:text-5xl">Configuración global</h1>
        <p className="mt-3 max-w-2xl text-sm text-slate-600 sm:text-base">Ajusta la suscripción, límites del mentor y alertas sin tocar código.</p>
      </div>
      {error && <p className="mb-6 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700" data-testid="admin-error">{error}</p>}
      <div className="grid gap-6 xl:grid-cols-[1fr_400px]">
        <div>{settings ? <AdminSettingsForm initial={settings} /> : !error && <div className="h-64 animate-pulse rounded-2xl bg-slate-100" />}</div>
        <aside className="space-y-6"><ProdResetCard /><AdminUsersPanel users={users} /><AdminEmailCard /><DemoPurgeCard onDone={load} /><InternalUsersCard onDone={load} /></aside>
      </div>
      <AdminBillingCard />
      <AdminMentorPanel />
    </section>
  );
}
